import script from "./SiteFaq.vue?vue&type=script&setup=true&lang=ts"
export * from "./SiteFaq.vue?vue&type=script&setup=true&lang=ts"

import "./SiteFaq.vue?vue&type=style&index=0&id=4558f31e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4558f31e"]])

export default __exports__